module.exports = __webpack_public_path__ + "static/media/groupon-logo.13f883ea.svg";